import styled from "styled-components";

export const FooterWrapper = styled.div`
    width: 100%;
    background: #222;
    color: #fff;
`;

export const FooterText = styled.p`
    text-align: center;
    padding: 30px 40px;
    font-size: 14px;
    word-wrap: break-word;
`;

export const Highlight = styled.span`
    color: #ffb727;
`;
